import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MerchantPageShell from "../../components/merchant/MerchantPageShell";
import {
  createBoutique,
  getMyBoutiques,
  updateBoutique,
} from "../../lib/boutiqueApi";
import { updateOnboarding } from "../../lib/onboardingApi";
import { COUNTRIES } from "../../constants/countries";

export default function MerchantBoutiqueDetails() {
  const navigate = useNavigate();
  const location = useLocation();
  const prefillBoutiqueName =
    location.state?.prefillBoutiqueName?.trim() || "";
  const [existingBoutiqueId, setExistingBoutiqueId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const [form, setForm] = useState({
    boutiqueName: prefillBoutiqueName,
    websiteUrl: "",
    description: "",
    country: "",
  });

  useEffect(() => {
    async function loadBoutique() {
      setLoading(true);
      setError("");

      try {
        const boutiques = await getMyBoutiques();
        const boutique =
          Array.isArray(boutiques) && boutiques.length ? boutiques[0] : null;

        if (boutique) {
          setExistingBoutiqueId(boutique.id);
          setForm({
            boutiqueName: boutique.name || "",
            websiteUrl: boutique.website_url || "",
            description: boutique.description || "",
            country: boutique.country || "",
          });
        }
      } catch (err) {
        console.error("Failed to load boutique", err);
        setError(err?.message || "Could not load boutique details");
      } finally {
        setLoading(false);
      }
    }

    loadBoutique();
  }, []);

  function updateField(key, value) {
    setForm((prev) => ({ ...prev, [key]: value }));
  }

  async function handleContinue() {
const payload = {
  name: form.boutiqueName.trim(),
  description: form.description.trim() || null,
  website_url: form.websiteUrl.trim() || null,
  country: form.country,
};

    if (!payload.name) {
      setError("Boutique name is required.");
      return;
    }

    if (!payload.country) {
      setError("Country is required.");
      return;
    }

    setSaving(true);
    setError("");

    try {
      if (existingBoutiqueId) {
        await updateBoutique(existingBoutiqueId, payload);
      } else {
        const created = await createBoutique(payload);
        setExistingBoutiqueId(created.id);
      }

      await updateOnboarding({
        boutique_details_completed: true,
        current_step: "boutique",
      });

      navigate("/merchant/dashboard/catalog");
    } catch (err) {
      console.error("Failed to save boutique", err);
      setError(err?.message || "Could not save boutique details");
    } finally {
      setSaving(false);
    }
  }

  return (
    <MerchantPageShell
      eyebrow="Merchant Setup"
      title="Complete your boutique profile"
      lede="Set the basic public-facing details for your boutique inside Veya. You can refine this later."
      onboardingStep="boutique"
    >
      {loading ? (
        <div className="public-card">
          <div className="public-card-title">Loading boutique details</div>
          <div className="public-card-sub">Fetching your saved boutique.</div>
        </div>
      ) : (
        <form className="merchant-form">
          <label className="merchant-field">
            <span className="merchant-label">Boutique name</span>
            <input
              className="merchant-input"
              value={form.boutiqueName}
              onChange={(e) => updateField("boutiqueName", e.target.value)}
              placeholder="Atelier Edit"
            />
          </label>

          <label className="merchant-field">
            <span className="merchant-label">Website</span>
            <input
              className="merchant-input"
              value={form.websiteUrl}
              onChange={(e) => updateField("websiteUrl", e.target.value)}
              placeholder="https://yourstore.com"
            />
          </label>

          <label className="merchant-field">
  <span className="merchant-label">Country</span>
  <select
    className="merchant-input"
    value={form.country}
    onChange={(e) => updateField("country", e.target.value)}
  >
    <option value="">Select country</option>
{COUNTRIES.map((country) => (
  <option key={country.code} value={country.code}>
    {country.label}
  </option>
))}
  </select>
</label>

          <label className="merchant-field">
            <span className="merchant-label">Short description</span>
            <textarea
              className="merchant-input merchant-textarea merchant-textarea--compact"
              value={form.description}
              onChange={(e) => updateField("description", e.target.value)}
              placeholder="Contemporary womenswear focused on natural fibres and relaxed tailoring."
            />
          </label>

          {error ? <div className="merchant-error">{error}</div> : null}

          <div className="merchant-actions">
            <button
              className="gold-btn"
              type="button"
              onClick={handleContinue}
              disabled={saving}
            >
              {saving ? "Saving..." : "Save and continue to catalog"}
            </button>
          </div>
        </form>
      )}
    </MerchantPageShell>
  );
}